var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.961689 5.87698C1.02716 5.86635 1.09341 5.86145 1.1597 5.86231H12.4474L12.2013 5.74783C11.9607 5.63396 11.7418 5.47898 11.5544 5.28991L8.3891 2.12456C7.97221 1.72661 7.90217 1.08642 8.2231 0.607715C8.59662 0.0976035 9.31294 -0.013155 9.82309 0.360369C9.8643 0.390563 9.90348 0.423476 9.94029 0.458892L15.6642 6.18285C16.1116 6.62968 16.112 7.35451 15.6651 7.80184C15.6649 7.80212 15.6645 7.80244 15.6642 7.80273L9.94029 13.5267C9.4926 13.9731 8.76777 13.9721 8.3213 13.5244C8.28617 13.4892 8.25337 13.4517 8.2231 13.4122C7.90217 12.9335 7.97221 12.2933 8.3891 11.8954L11.5487 8.72429C11.7167 8.55615 11.9098 8.41516 12.1211 8.30644L12.4646 8.15189H1.2227C0.637891 8.17361 0.124809 7.76509 0.014945 7.19027C-0.0862617 6.56618 0.337599 5.97822 0.961689 5.87698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button-arrow.c6581b50c3581ff588d6e6e12040f9e4.svg";
export { ForwardRef as ReactComponent };